<template>
  <div class="haizol-header">
    <div class="haizol-header-container" >
      <a class="header-container-l hzol-logo"
        v-if="userInfo.traderThemeInfo?.themeInfo"
        :href="userInfo.traderThemeInfo.themeInfo.siteUrl"
      >
        <img class="hzol-logo-img" :src="userInfo.traderThemeInfo.themeInfo.logoUrl" alt="" />
      </a>
      <a class="header-container-l hzol-logo" :href="homeUrl" v-else>
        <img class="hzol-logo-img" :src="logoPng" alt="" />
      </a>
      <div class="header-container-c">
        <a
          class="header-current-position"
          href="javascript:void(0);"
          @click="reloadOrToHome"
        >
          <i class="iconfont icon-icon-zhuye"></i>
          <span class="position-txt">控制台</span>
        </a>
        <div class="header-membership-info">
          <!-- 默认会员头像 -->
          <img
            v-if="!userInfo.userMemberInfoVo"
            class="level-logo"
            src="https://res.haizol.com/base/images/membership/new/vip0.png"
            alt
          />
          <template v-else>
            <!-- 黄金会员 -->
            <img
              v-if="userInfo.userMemberInfoVo.memberType == 1"
              class="level-logo"
              src="https://res.haizol.com/base/images/membership/new/vip_gold.png"
              alt
            />
            <!-- 铂金/新铂金 -->
            <img
              v-if="
                userInfo.userMemberInfoVo.memberType == 2 ||
                userInfo.userMemberInfoVo.memberType == 5
              "
              class="level-logo"
              src="https://res.haizol.com/base/images/membership/new/vip_platinum.png"
              alt
            />
            <!-- 钻石 -->
            <img
              v-if="userInfo.userMemberInfoVo.memberType == 3"
              class="level-logo"
              src="https://res.haizol.com/base/images/membership/new/vip_diamond.png"
              alt
            />
            <!-- VIP会员 -->
            <img
              v-if="userInfo.userMemberInfoVo.memberType == 4"
              class="level-logo"
              src="https://res.haizol.com/base/images/membership/new/vip_lifetime.png"
              alt
            />
            <!-- 智展宝 -->
            <img
              v-if="userInfo.userMemberInfoVo.memberType == 6"
              class="level-logo"
              src="https://res.haizol.com/base/images/membership/vip_smartshow.png"
              alt
            />
            <!-- 至尊VVIP会员 -->
            <img
              v-if="userInfo.userMemberInfoVo.memberType == 7"
              class="level-logo"
              src="https://res.haizol.com/base/images/membership/new/vip_vvip.png"
              alt
            />
            <!-- 工脉拓会员 -->
            <img
              v-if="userInfo.userMemberInfoVo.memberType == 8"
              class="level-logo"
              src="https://res.haizol.com/base/images/membership/new/vip_engineering_expansion.png"
              alt
            />
          </template>
          <p
            style="display: inline-block"
            slot="reference"
            class="company-name"
            @mouseover="onMouseOver('companyName')"
          >
            <el-tooltip
              :content="userInfo.compCnName"
              placement="bottom"
              :disabled="isShowTooltip"
              effect="light"
            >
              <span ref="companyName">{{ userInfo.compCnName }}</span>
            </el-tooltip>
          </p>
          <!-- :style="!isShowTooltip ?'cursor:pointer':'' " -->
        </div>
      </div>
      <div class="header-container-r">
        <div class="header-entrys">
          <span
            class="header-entrys-Ai"
            @click="openAI"
            v-if="$store.state.subscribeKit"
          >
            <img src="@/assets/image/AI.gif" alt="" style="width: 40px" />
            <span>&nbsp; &nbsp; AI助手</span>
          </span>
          <!-- 公众号 -->
          <el-popover
            v-if="!userInfo.traderThemeInfo?.themeInfo"
            placement="bottom-end"
            width="381"
            trigger="hover"
            popper-class="wxprogrampopper"
          >
            <div class="wx-program-img">
              <img src="https://res.haizol.com/marketing/logo/qr/hz-supplier-tips.jpg" alt />
            </div>
            <!-- <el-button slot="reference">hover 激活</el-button> -->
            <span slot="reference" class="header-entrys-item">
              <i class="iconfont icon-icon-gongzhonghao2 wx-program"></i>
              <span class="entry-name">公众号</span>
            </span>
          </el-popover>
          <!-- 小程序 -->
          <el-popover v-if="!userInfo.traderThemeInfo?.themeInfo" placement="bottom" width="80" trigger="hover">
            <div class="mini-program-img">
              <img
                src="https://res.haizol.com/marketing/logo/qr/hz-supplier-app.jpg"
                alt
              />
              <div>微信扫码体验小程序</div>
              <div>即刻开启移动端之旅</div>
            </div>
            <span slot="reference" class="header-entrys-item">
              <i class="iconfont icon-icon-xiaochengxu2 mini-program"></i>
              <span class="entry-name">小程序</span>
            </span>
          </el-popover>
          <el-popover placement="bottom" width="210" trigger="hover">
            <div class="exclusive-programpopover">
              <div class="name">{{ salesInfoGetter.userName }}</div>
              <div class="exclusive-pname">客户经理</div>
              <div class="am-info-item">
                <i class="iconfont icon-icon-shoujihao"></i
                >{{ salesInfoGetter.phone }}
              </div>
              <div class="am-info-item">
                <i class="iconfont icon-icon-zuojihao"></i
                >{{ salesInfoGetter.tel }}
              </div>
              <div class="am-info-item">
                <i class="iconfont icon-icon-zuojihaobeifen"></i
                ><a
                  class="am-info-item-value email"
                  :href="`mailto:${salesInfoGetter.email}`"
                  >{{ salesInfoGetter.email }}</a
                >
              </div>
            </div>
            <span slot="reference" class="header-entrys-item">
              <i class="iconfont icon-icon-kefu exclusive-program"></i>
              <span class="entry-name">专属客服</span>
            </span>
          </el-popover>

          <span class="header-entrys-item header-entrys-span">
            <el-popover
              placement="bottom"
              :visible-arrow="false"
              width="200"
              popper-class="header-expense-popover"
              trigger="click"
              @show="headerExpensePopoverShow"
              @hide="headerExpensePopoverHide"
            >
              <span slot="reference">
                <span ref="headerExpensePopoverTrigger" class="entry-name"
                  >费用</span
                >
                <i class="el-icon-arrow-down cost-down"></i>
              </span>
              <template>
                <div class="content">
                  <div class="title" v-if="orderInfo.subscribeLevel.length">
                    <h6>智工嗨搜</h6>
                    <p>
                      {{
                        orderInfo.subscribeLevel[0]
                          ? orderInfo.subscribeLevel[0].subscribeName
                          : "---"
                      }}
                    </p>
                  </div>
                  <div
                    class="box"
                    v-if="
                      orderInfo.subscribeLevel.length &&
                      orderInfo.resourceKit.length
                    "
                  >
                    <div
                      class="li"
                      v-for="item in orderInfo.resourceKit"
                      :key="item.subscribeCode"
                    >
                      <div class="label">
                        {{
                          item.subscribeCode === "HISE-CNT"
                            ? "已使用收件人信用点数"
                            : "已使用营销邮件数"
                        }}
                      </div>
                      <div class="progress">
                        <el-progress
                          :show-text="false"
                          :percentage="getProgressNum(item)"
                        ></el-progress>
                        <div class="num">
                          <b>{{ item.usedQuantity }}</b>
                          <span>/{{ item.totalQuantity }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- 0元试用 -->
                  <div class="box" v-else-if="orderInfo.subscribeLevel.length">
                    <div class="li">
                      <div class="label">已使用收件人信用点数</div>
                      <div class="progress">
                        <el-progress
                          :show-text="false"
                          :percentage="0"
                        ></el-progress>
                        <div class="num">
                          <b>{{ 0 }}</b>
                          <span>/{{ 0 }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="li">
                      <div class="label">已使用营销邮件数</div>
                      <div class="progress">
                        <el-progress
                          :show-text="false"
                          :percentage="0"
                        ></el-progress>
                        <div class="num">
                          <b>{{ 0 }}</b>
                          <span>/{{ 0 }}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="links">
                    <!-- ? 套餐购买入口在6.13号的版本隐藏了 MKP-12168 -->
                    <div class="link" @click="handleOrderLink(0)" v-if="false">
                      <i class="iconfont icon-icon-taocangoumai"></i>
                      <span>套餐购买</span>
                    </div>
                    <div class="link" @click="handleOrderLink(1)">
                      <i class="iconfont icon-icon-daijinzhang"></i>
                      <span>购买记录</span>
                      <b v-if="orderInfo.waitPayCount"
                        >待支付{{ orderInfo.waitPayCount || 0 }}笔</b
                      >
                    </div>
                    <div class="link" @click="jumpUrl(1)">
                      <i class="iconfont icon-fapiao"></i>
                      <span>平台发票</span>
                    </div>
                    <div class="link" @click="jumpUrl(2)">
                      <i class="iconfont icon-hetong"></i>
                      <span>平台合同</span>
                    </div>
                  </div>
                </div>
              </template>
            </el-popover>
          </span>
        </div>
        <!-- <a :href="`${onlineUrl}/member/info`" target="_blank">
          <div class="custom-info">
            <span class="custom-name-first"
              ><i class="iconfont icon-icon-renwuxinxi"></i
            ></span>
            <span class="custom-name">{{ userInfo.userName }}</span>
          </div>
        </a> -->
        <div>
          <div class="haizol-head-r-avator" @click="handleShowDownList">
            <el-avatar :size="36" class="avator">{{
              userInfo.userName ? userInfo.userName.slice(0, 1) : "-"
            }}</el-avatar>
            <span
              class="customname"
              :style="showDownVisible ? 'color: #066eb7' : ''"
              >{{ userInfo.userName }}</span
            >
            <i
              class="el-icon-caret-bottom customname-icon"
              v-show="!showDownVisible"
            ></i>
            <i
              class="el-icon-caret-top customname-icon"
              style="color: #066eb7"
              v-show="showDownVisible"
            ></i>
          </div>
          <DropDownList
            v-if="showDownVisible"
            :visible="showDownVisible"
            :switchUserVisible="switchUserVisible"
            :comList="comList"
            :multiUserMax="multiUserMax"
            :activate="activate"
            :top="73"
            :right="17"
            @SwitchUser="handleSwitchUser"
            @Administration="handleAdministration"
            @CreateDialog="handleCreateDialog"
            @cutActivate="handleActivate"
            @UserLogout="handleUserLogout"
          ></DropDownList>
        </div>
      </div>
    </div>

    <HeaderAIAbility
      ref="AIAbility"
      @AIdrawer="AIdrawer"
      :headerAIDrawer="drawer"
    />
    <CreateCompanyDialog
      :visible="createVisible"
      @close="handleCloseDialog"
    ></CreateCompanyDialog>
    <div class="mask" @click="handleMask" v-if="showDownVisible"></div>
    <!-- 身份验证 手机号/邮箱 -->
    <AuthenticationUserDialog
      :type="authenticationType"
      :visible="authenticationVisible"
      :isPassword="isPassword"
      :typeCode="typeCode"
      :info="info"
      @close="handleClosAuthenticationDialog"
      @submit="handleSubmitAuthenticationDialog"
    ></AuthenticationUserDialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { appUrl, onlineUrl, passportUrl, presentUrl, homeUrl } from "@/utils/config";
import { getOrderCostHeader } from "@/utils/api/order.js";
import { salesInfo } from "@/utils/api/dashboard";
import { getUserInfo } from "@/utils/api";
import HeaderAIAbility from "@/components/headerAIAbility";
import { getCompanyList, cutCompany, userLogout } from "@/utils/api/account";
import CreateCompanyDialog from "@/components/common/CreateCompanyDialog.vue";
import DropDownList from "@/components/common/DropDownList.vue";
import AuthenticationUserDialog from "@/components/common/AuthenticationUserDialog.vue";
import {
  getUserSecurityInfo,
} from "@/utils/api/account";
import getLang from '@/utils/getLang';
export default {
  data() {
    return {
      logoPng: "https://res.haizol.com/marketing/logo/hz-default.svg",
      onlineUrl,
      passportUrl,
      homeUrl,
      presentUrl,
      routeName1: ["dashboard"],

      orderInfo: {
        resourceKit: [],
        subscribeLevel: [],
        waitPayCount: null,
      },
      accountManagerInfo: {},
      isProgress: true,
      drawer: false,
      isShowTooltip: false,
      comList: [], // 企业列表
      multiUserMax:0,// 企业列表数量限制
      activate: undefined, // 当前激活的企业下标
      showDownVisible: false, // 下拉菜单
      switchUserVisible: false, // 企业账号切换
      createVisible: false, //创建企业弹框
      userId: undefined,
      companyName: "",
      authenticationType: "phone", // phone  手机   email 邮箱
      authenticationVisible: false, //身份验证弹窗
      isPassword: false, // 是否是修改密码的身份验证
      typeCode: undefined, //1：解绑手机/邮箱 2：更换手机/邮箱-新手机号/新邮箱发送验证码 3:绑定手机 4:更换手机/邮箱-已绑定手机号/邮箱发送验证码 5:已绑定手机号/邮箱安全校验 6:重置密码-已绑定手机号/邮箱发送验证码,示例值(4)
      info: {},
    };
  },
  components: {
    HeaderAIAbility,
    DropDownList,
    CreateCompanyDialog,
    AuthenticationUserDialog,
  },
  computed: {
    ...mapGetters(["salesInfoGetter"]),
    ...mapState(["userInfo"]),
    ...mapState("permissionVerification", ["accessData"]),
    // 计算百分比
    getProgressNum() {
      return (val) => {
        return (val.usedQuantity || 0) / ((val.totalQuantity || 0) / 100);
      };
    },
  },
  methods: {
    //身份验证弹窗 关闭
    handleClosAuthenticationDialog(type) {
      console.log(type);
      this.authenticationVisible = false;
    },
    //身份验证弹窗 提交 isPassword == true 修改密码身份验证  false 是邮箱 手机号验证
    async handleSubmitAuthenticationDialog(type, isPassword) {
      if (!isPassword) {
        this.authenticationVisible = false;
        if (!this.switchUserVisible) {
          await this.getCompanyListFn();
          if (this.comList.length) {
            this.switchUserVisible = !this.switchUserVisible;
          }
        } else {
          this.switchUserVisible = !this.switchUserVisible;
        }
      }
    },

    // 创建企业成功后  重新获取企业列表
    handleCloseDialog() {
      this.createVisible = false;
      this.getCompanyListFn();
    },
    // 创建企业弹框
    handleCreateDialog() {
      this.createVisible = true;
    },

    // 点击退出登录
    handleUserLogout() {
      const that = this;
      this.$msgbox({
        title: "提示",
        message: "是否确认登出当前账号?",
        type: "warning",
        customClass: "message-box-common",
        showCancelButton: true,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        beforeClose(action, instance, done) {
          if (action === "confirm") {
            instance.confirmButtonLoading = true;
            that.userLogoutSendFn();
          } else {
            done();
          }
        },
      }).catch((action) => {
        // 取消
      });
    },

    //退出登录接口
    async userLogoutSendFn() {
      try {
        const res = await userLogout();
        if (res.rspResult.bizCode === 200) {
          this.showDownVisible = false;
          window.location.replace(onlineUrl);
        }
      } catch (error) {
        console.log("error", error);
      }
    },

    // 点击遮罩层
    handleMask(event) {
      this.switchUserVisible = false;
      this.showDownVisible = !this.showDownVisible;
    },
    // 获取信息
    userSecurityInfoSendFn(){
      getUserSecurityInfo().then((res) => {
      const bizCode = res.rspResult.bizCode;
      if (bizCode === 200) {
        this.authenticationVisible = true;
          this.authenticationType = "phone";
          this.isPassword = false;
          this.typeCode = 5;
          this.info = {
          telCode:res.data.telCode,
          mobile: res.data.mobile,
          };
      }
    }).catch((err) => {
    });
    },
    //获取服务类型
    async getCompanyListFn() {
      try {
        const params = { refresh: true };
        const res = await getCompanyList(params);
        console.log(res);
        if (res.rspResult.bizCode === 200) {
          this.multiUserMax =res.data.multiUserMax
          this.comList = res.data.userLoginInfoList.map((data, index) => {
            if (data.userId === this.userInfo.userId) {
              this.activate = index;
              // this.userId = data.userId;
            }
            return {
              ...data,
              identityText:
                data.compType === 1
                  ? "供应商"
                  : data.compType === 2
                  ? "采购商"
                  : "服务商",
              tooltipFlag: false,
            };
          });
        }else if (res.rspResult.bizCode === 1206){
     
       window.location.replace(
          `${onlineUrl}/purchase-order/supplier/administration/account-info?type=bindMobile`,
          "_blank"
        );
        handleMask();
    

    } else if (res.rspResult.bizCode === 14000) {
          this.userSecurityInfoSendFn()
        }
      } catch (error) {
        console.log("error", error);
      }
    },

    // 点击切换用户
    async handleSwitchUser(item) {
      if (item.type == 1) {
        window.location.replace(
          `${onlineUrl}/purchase-order/supplier/administration/account-info`,
          "_blank"
        );
      } else if (item.type == 3) {
        if (!this.switchUserVisible) {
          await this.getCompanyListFn();
          if (this.comList.length) {
            this.switchUserVisible = !this.switchUserVisible;
          }
        } else {
          this.switchUserVisible = !this.switchUserVisible;
        }
      }else if (item.type == 4) {
      window.open((getLang() == 'cn' ? homeUrl : onlineUrl) +'/member/info');
      } else if (item.type == 5) {
      window.open((getLang() == 'cn' ? homeUrl : onlineUrl) +'/member/products');
     }
    },
    // 跳转至企业管理
    handleAdministration() {
      this.handleMask();
      window.location.replace(
        `${onlineUrl}/purchase-order/supplier/administration/administration-info`,
        "_blank"
      );
    },
    // 下拉菜单点击事件
    handleShowDownList(item) {
      console.log(item);
      this.switchUserVisible = false;
      this.showDownVisible = !this.showDownVisible;
    },
    // 切换用户二次弹框确认
    handleActivate(index, item) {
      console.log(item, this.userInfo);
      if (item.userId === this.userInfo.userId) return;
      this.activate = index;
      this.userId = item.userId;
      const that = this;
      this.$msgbox({
        title: "提示",
        message: "确认并切换至该企业账号？",
        type: "warning",
        customClass: "message-box-common",
        showCancelButton: true,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        beforeClose(action, instance, done) {
          console.log(instance, 11111111111);

          if (action === "confirm") {
            that.cutCompanySendFn(done, instance, item);
          } else {
            done();
          }
        },
      }).catch((action) => {
        this.activate = this.comList.findIndex(
          (item) => item.userId === this.userInfo.userId
        );
        // 取消
      });
    },
    // 同意 - 切换账号
    async cutCompanySendFn(done, instance, item) {
      console.log(item);
      instance.confirmButtonLoading = true;
      try {
        const params = {
          userId: this.userId,
        };
        const res = await cutCompany(params);
        if (res.rspResult.bizCode === 200) {
          done();
          if (item.compType === 1) {
            if(item.compStateId==247){
            window.location.replace(presentUrl);
          } else{
            window.location.replace(onlineUrl + "/work-panel/supplier-work-panels");
          }
          } else if (item.compType === 2) {
            if (item.memberType==2) {
             window.location.replace( appUrl + "/purchase-order/buyer/dashboard")
            }else{
            window.location.replace(
              appUrl + "/purchase-order/buyer/dashboard"
            );
          }
          } else {
            window.location.replace(baseUrl);
          }
          this.$message.success(res.rspResult.message);
        }
      } catch (err) {
        console.error("同意取消订单失败", err);
      }
      instance.confirmButtonLoading = false;
    },

    // 公司名称判断是否移溢出

    onMouseOver(str) {
      if (str === "companyName") {
        const tag = this.companyName;
        const parentWidth = tag.parentNode.offsetWidth; // 获取元素父级可视宽度
        const contentWidth = tag.offsetWidth; // 获取元素可视宽度
        this.isShowTooltip = contentWidth <= parentWidth;
      }
    },

    ...mapActions("permissionVerification", ["requestAccessData"]),
    onMouseOver(str) {
      if (str === "companyName") {
        const tag = this.$refs[str];
        const parentWidth = tag.parentNode.offsetWidth; // 获取元素父级可视宽度
        const contentWidth = tag.offsetWidth; // 获取元素可视宽度
        this.isShowTooltip = contentWidth <= parentWidth;
      }
    },
    openAI() {
      // console.log('打开弹框');
      this.drawer = true;
    },
    AIdrawer(val) {
      this.drawer = false;
    },
    getsalesInfo() {
      salesInfo()
        .then((res) => {
          if (res.rspResult.bizCode == 200) {
            this.accountManagerInfo = res.data;
          }
        })
        .catch((err) => {
          console.error("查询客户经理信息失败", err);
        });
    },
    // 当没权限时，路由跳转前会再请求并校验一次身份，符合放行，不符合直接403
    checkUserInfo() {
      return new Promise((resolve, reject) => {
        getUserInfo()
          .then((res) => {
            if (res.rspResult.bizCode == 200) {
              if (res.data.compId) {
                if (res.data.compType === 1) {
                  if (!res.data.expireLongTime) {
                    console.log("getUserInfo", res.data);
                    this.$store.commit("SET_USERINFO", res.data);
                    this.$store.commit("SET_PERMISSION", true);
                    resolve(true);
                  } else {
                    window.location.replace(
                      `${onlineUrl}/supplier-service/expire`
                    );
                  }
                } else {
                  resolve(false);
                }
              } else {
                // const href = `${loginUrl}/pst/login?returnURL=${window.location.href}`
                // window.location.href = href;
              }
            } else {
              resolve(false);
            }
          })
          .catch((err) => {
            reject("getUserInfo Error!");
          });
      });
    },
    // 获取头部费用信息
    async getOrderInfo() {
      this.isProgress = false;
      try {
        const res = await getOrderCostHeader();
        if (res.rspResult.bizCode === 200) {
          this.orderInfo = res.data;
        }
      } catch (err) {
        console.error("❌ ~ file: header.vue:329 ~ getOrderInfo ~ err:", err);
      }
    },

    // 点击我的订单 || 选购套餐
    async handleOrderLink(type) {
      let router = null;
      const newPage = window.open("");
      if (type) {
        // 我的订单
        router = this.$router.resolve({
          name: "const-center-my-order",
        });
      } else {
        // 选购套餐
        if (!this.accessData) await this.requestAccessData();
        const accessPermission = this.accessData?.accessPermission;
        // 只有开通了产品才支持去选购套餐
        if (accessPermission === 1 || accessPermission === 5) {
          router = this.$router.resolve({
            name: "const-center-meal-choose",
          });
        } else {
          router = this.$router.resolve({
            name: "boot-page-home",
          });
        }
      }
      newPage.location.href = router.href;
    },
    // 跳转
    jumpUrl(type) {
      if (type == 1) {
        // 发票
        // /cost-center/my-invoice
        const router = this.$router.resolve({
          name: "const-center-my-invoice",
        });
        console.log(router.href);

        window.open(router.href, "_blank");
      }
      if (type == 2) {
        // 合同
        // ${onlineUrl}/supplier/invoice/list
        window.open(`${onlineUrl}/supplier/invoice/list`, "_blank");
      }
    },
    headerExpensePopoverShow() {
      try {
        this.getOrderInfo();
        this.$refs.headerExpensePopoverTrigger.classList.add("trigger-active");
      } catch (err) {
        console.error(
          "❌ ~ file: header.vue:371 ~ headerExpensePopoverShow ~ err:",
          err
        );
      }
    },

    headerExpensePopoverHide() {
      try {
        this.$refs.headerExpensePopoverTrigger.classList.remove(
          "trigger-active"
        );
      } catch (err) {
        console.error(
          "❌ ~ file: header.vue:381 ~ headerExpensePopoverHide ~ err:",
          err
        );
      }
    },
    reloadOrToHome() {
      if (!["/", "/dashboard"].includes(this.$route.path)) {
        return this.$router.push("/");
      }
      return window.location.reload();
    },
  },
  created() {
    // this.getsalesInfo()
    this.$store.dispatch("getSalesInfo");
    // this.checkUserInfo();  //把store中的isPermission初始值设为false，且不保存在缓存中，让用户每次进来都先调一次checkUserInfo的dispatch，所以这里就不去重复调了；
  },
};
</script>

<style lang="scss" scoped>
.mask {
  // background-color: rgba(0, 0, 0, 0.5);
  position: absolute;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 9;
}
.haizol-head-r-avator {
  display: flex;
  align-items: center;
  margin: 0px 32px 0px 36px;
  position: relative;
  cursor: pointer;
  .avator {
    margin-right: 8px;
    color: #fff;
    line-height: 24px;
    background-color: #256bff;
  }
  .customname {
    color: #16181a;
    font-family: SourceHanSansCN-Regular;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    max-width: 120px;
        white-space: nowrap;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    // margin-left: 4px;
  }
  .customname-icon {
    color: #16181a;
    font-size: 12px;
    margin-left: 8px;
  }
}
.haizol-head-r-avator:hover {
  .customname,
  .customname-icon {
    color: #066eb7;
  }
}
.haizol-header {
  width: 100%;
  height: 72px;
  position: relative;
  z-index: 10;
  background: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.04);
  &-container {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    .header-container-l {
      height: 40px;
      line-height: 38px;
      margin: 0 60px 0 28px;
      .hzol-logo-img {
        width: 123px;
        // height: 20px;
      }
    }
    .header-container-c {
      display: flex;
      align-items: center;
      margin-left: 20px;
      .header-current-position {
        position: relative;
        height: 16px;
        line-height: 16px;
        font-family: SourceHanSansCN-Medium;
        font-weight: 500;
        font-size: 14px;
        color: #16181a;
        // cursor: auto;
        .iconfont {
          font-size: 16px;
          line-height: 16px;
        }
        .position-txt {
          display: inline-block;
          margin: 0 20px 0 5px;
        }
        &::after {
          content: " ";
          position: absolute;
          top: 0;
          right: 0;
          display: block;
          height: 100%;
          width: 0;
          border-right: 1px solid #e5e8ed;
        }
      }
      .header-membership-info {
        margin-left: 20px;
        height: 18px;
        line-height: 18px;
        font-family: SourceHanSansCN-Regular;
        font-size: 14px;
        color: #16181a;
        letter-spacing: 0;
        display: flex;
        align-items: center;
        .level-logo {
          width: 18px;
          height: 18px;
          margin-right: 5px;
        }
        .company-name {
          line-height: 18px;
          max-width: 290px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
    .header-container-r {
      margin-left: auto;
      display: flex;
      align-items: center;
      .header-entrys {
        height: 100%;
        position: relative;
        img {
          position: absolute;
          top: -10px;
          left: -20px;
          width: 42px;
          height: 40px;
        }
        &-Ai {
          display: inline-block;
          width: 80px;
          text-align: center;
          color: #fff;
          background: linear-gradient(243deg, #00ffa3 1%, #0046d2 58%);
          border-radius: 15px;
          margin-right: 24px;
          font-family: SourceHanSansCN-Regular;
          cursor: pointer;
          span {
            font-size: 14px;
            line-height: 24px;
          }
        }
        &-item {
          height: 16px;
          // margin:0 20px;
          margin-right: 24px;
          line-height: 16px;
          font-family: SourceHanSansCN-Regular;
          font-size: 14px;
          color: #333;
          letter-spacing: 0;
          cursor: pointer;
          user-select: none;
          .iconfont {
            font-size: 14px;
            line-height: 16px;
            // color: #20b820;
            margin-right: 5px;
          }
          .wx-program {
            color: #066eb7;
          }
          .mini-program {
            color: #20b820;
          }
          .exclusive-program {
            color: #ff7f2a;
          }
          // 费用下拉箭头
          .cost-down {
            font-size: 12px;
            margin-left: 4px;
            transform: rotate(0deg);
            transition: transform 0.3s;
          }
        }
        .header-entrys-span {
          margin-right: 4px;
        }
        &-item:hover {
          color: #066eb7 !important;
          .iconfont {
            color: #066eb7 !important;
          }
        }
      }
      .custom-info {
        margin-left: 20px;
        padding-right: 30px;
        height: max-content;
        display: flex;
        align-items: center;
        cursor: pointer;
        .custom-name-first {
          width: 28px;
          height: 28px;
          background: #98a3b7;
          line-height: 26px;
          border-radius: 50%;
          font-family: Arial;
          font-weight: 700;
          font-size: 18px;
          color: #fff;
          text-align: center;
          letter-spacing: 0;
          user-select: none;
          margin-right: 8px;
          .iconfont {
            font-size: 16px;
          }
        }
        .custom-name {
          max-width: 60px;
          height: 14px;
          line-height: 14px;
          font-family: SourceHanSansCN-Regular;
          font-size: 14px;
          color: #333;
          letter-spacing: 0;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
  }
  .trigger-active {
    color: #066eb7;
    & + .cost-down {
      transform: rotate(180deg) !important;
    }
  }
}
</style>
<style lang="scss">
.header-expense-popover {
  top: 61px !important;
  width: 307px !important;
  background: #ffffff;
  box-shadow: 0 2px 6px 0 #0014331a;
  border-radius: 0 0 4px 4px;
  box-sizing: border-box;
  padding: 20px !important;
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 16px;
    > h6 {
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #16181a;
    }
    > p {
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      font-size: 12px;
      color: #4f5d78;
    }
    margin-bottom: 16px;
  }
  .box {
    padding: 16px 18px 4px 12px;
    padding-right: 0;
    background: #f3f5f8;
    margin-bottom: 12px;
    .li {
      margin-bottom: 16px;
      .label {
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        font-size: 12px;
        color: #4f5d78;
        height: 12px;
        line-height: 12px;
        margin-bottom: 11px;
      }
      .progress {
        height: 14px;
        display: flex;
        align-items: center;
        .el-progress {
          width: 160px;
          margin-right: 12px;
          .el-progress-bar__outer {
            background-color: #fff !important;
          }
        }
      }
      .num {
        b {
          color: #16181aff;
          font-size: 12px;
        }
        span {
          color: #4f5d78ff;
          font-size: 12px;
        }
      }
    }
  }
  .links {
    .link {
      cursor: pointer;
      position: relative;
      display: flex;
      // width: 253px;
      height: 38px;
      background: #fff;
      border-radius: 4px;
      align-items: center;
      padding-left: 12px;
      box-sizing: border-box;
      &:hover {
        background: #f5f7fa;
        span,
        i {
          color: #066eb7;
        }
      }
    }
    i {
      font-size: 14px;
      color: #16181a;
      height: 14px;
      line-height: 14px;
    }
    span {
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #16181a;
      margin-left: 7px;
      height: 14px;
      line-height: 14px;
    }
    b {
      position: absolute;
      right: 12px;
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      font-size: 12px;
      color: #ff7f2a;
      height: 12px;
      line-height: 12px;
    }
  }
}
.mini-program-img {
  text-align: center;
  div {
    line-height: 26px;
    font-family: SourceHanSansCN-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #4f5d78;
  }
  img {
    width: 128px;
    height: 128px;
  }
}
.wx-program-img {
  width: 381px;
  height: 144px;
  img {
    width: 381px;
    height: 144px;
  }
}
.exclusive-programpopover {
  font-family: SourceHanSansCN-Medium;
  font-weight: 500;
  font-size: 14px;
  color: #16181a;
  .exclusive-pname {
    font-family: SourceHanSansCN-Regular;
    font-weight: 400;
    font-size: 12px;
    color: #4f5d78;
    margin-bottom: 16px;
    margin-top: 4px;
  }
  .am-info-item {
    // line-height: 28px;
    margin-top: 10px;
    display: flex;
    .iconfont {
      font-size: 12px;
      color: #ff7f2a;
      margin-right: 8px;
      line-height: 20px;
    }
    .am-info-item-value {
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #066eb7;
      line-height: 20px;
    }
  }
}
.el-tooltip__popper.is-light {
  background: #ffffff;
  border: 1px solid #ebeef5 !important;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.el-tooltip__popper.is-light[x-placement^="bottom"] .popper__arrow {
  border-bottom-color: #ebeef5 !important;
}
</style>
<style>
.wxprogrampopper {
  padding: 0px !important;
}
</style>
